module.exports = __webpack_public_path__ + "img/sixpackcarrier17.790ccd15.jpg";